<script>
import Overlay from "@core/components/common/Overlay.vue";
import HamletTable from "@core/components/common/HamletTable.vue";
import {getAllSubstanceLists} from "@core/domain/substance";
import {FilterInput} from "@core/components/common/filter";
import {
    BBadge
} from 'bootstrap-vue'
import VueSelectFilter from "@core/components/common/filter/VueSelectFilter.vue";

export default {
    components: {VueSelectFilter, FilterInput, HamletTable, Overlay, BBadge},
    data() {
        return {
            fetchCallback: null,
            config: null,
            showLoader: true,
            substances: [],
            substanceMap: {},
            substanceLists: [],

            filteredSubstances: [],

            columns: [
                {
                    key: 'id',
                    label: this.$t('Component(Grid):column-id'),
                    active: true,
                },
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-title'),
                    active: true,
                },
                {
                    key: 'ec',
                    label: this.$t('Component(SubstanceTable):column-ec'),
                    active: true,
                },
                {
                    key: 'cas',
                    label: this.$t('Component(SubstanceTable):column-cas'),
                    active: true,
                },
                {
                    key: 'lists',
                    label: this.$t('Component(Label):substance-list'),
                    active: true,
                },
            ]
        };
    },
    methods: {
        filterSubstances(filters) {
            if (Object.keys(filters).length === 0) {
                return this.substances;
            }

            let substances = this.substances;

            if (filters.id) {
                const id = filters.id.split(',').map(v => parseInt(v));
                substances = substances.filter(s => id.includes(s.id));
            }

            if (filters.title) {
                const title = filters.title.toLowerCase();
                substances = substances.filter(s => s.title.toLowerCase().indexOf(title) >= 0);
            }

            if (filters.lists && filters.lists.length > 0) {
                substances = substances.filter(s => {
                    let valid = true;

                    filters.lists.forEach((list) => {
                        if (!s.listIds.includes(list.id)) {
                            valid = false;
                        }
                    })

                    return valid;
                });
            }

            if (filters.cas) {
                substances = substances.filter(s => s.cas.indexOf(filters.cas) >= 0);
            }

            if (filters.ec) {
                substances = substances.filter(s => s.ec.indexOf(filters.ec) >= 0);
            }

            return substances;
        },
        fetch(config, cb) {
            const start = (config.page - 1) * config.perPage;
            const substances = this.filterSubstances(config.filters);

            cb(
                substances.length,
                substances.slice(start, start + config.perPage)
            );
        },
        onTableCreated(config, cb, showLoader) {
            this.config = config;
            this.fetchCallback = cb;
        },
        onRowClick(substance) {
            if (this.$can('visit', 'administration-substances-regulated-substances-edit')) {
                this.$router.push({
                    name: 'administration-substances-regulated-substances-edit',
                    params: {
                        id: substance.id
                    }
                })
            }
        },
        filter(field, value) {
            this.$refs.table.filter(field, value);
        }
    },
    created() {
        getAllSubstanceLists()
            .then((lists) => {
                return Promise
                    .all(lists.map(list => list.getSubstanceMap()))
                    .then(substancesMaps => {
                        return Promise.all(
                            lists.map(list => {
                                this.substanceLists.push({
                                    id: list.id,
                                    title: list.title
                                });
                                return list.getSubstanceMap().then(substanceMap => {
                                    Object.keys(substanceMap).forEach(id => {
                                        if (!this.substanceMap[id]) {
                                            const substance = {...substanceMap[id]};
                                            substance.lists = [
                                                {
                                                    id: list.id,
                                                    title: list.title
                                                }
                                            ];
                                            substance.listIds = [list.id];
                                            this.substances.push(substance);
                                            this.substanceMap[id] = substance;
                                        } else {
                                            this.substanceMap[id].lists.push({
                                                id: list.id,
                                                title: list.title
                                            });
                                            this.substanceMap[id].listIds.push(list.id);
                                        }
                                    });
                                });
                            })
                        );
                    })
                    .finally(() => {
                        this.fetch(this.config, this.fetchCallback);
                    })
                ;
            })
            .finally(() => {
                setTimeout(() => {
                    this.showLoader = false;
                }, 500);
            })
        ;
    }
}
</script>

<template>
    <Overlay :show="showLoader">
        <HamletTable
            ref="table"
            :columns="columns"
            :fetch="fetch"
            :search="true"
            @onRowClick="onRowClick"
            @created="onTableCreated"
        >
            <template #header-label>
                {{ $t('Component(RegulatedSubstances):label') }}
            </template>

            <template #cell-title="data">
                <div :title="data.item.title">{{ data.item.title.length > 64 ? data.item.title.substring(0, 64) + ' ...' : data.item.title }}</div>
            </template>

            <template #cell-lists="data">
                <b-badge class="mr-50" v-for="list in data.item.lists">{{ list.title }}</b-badge>
            </template>

            <template #filter-cell-id>
                <FilterInput
                    style="max-width: 100px;"
                    @search="(v) => filter('id', v)"
                />
            </template>

            <template #filter-cell-cas>
                <FilterInput
                    style="max-width: 140px;"
                    @search="(v) => filter('cas', v)"
                />
            </template>

            <template #filter-cell-ec>
                <FilterInput
                    style="max-width: 140px;"
                    @search="(v) => filter('ec', v)"
                />
            </template>

            <template #filter-cell-lists>
                <VueSelectFilter
                    :options="substanceLists"
                    style="max-width: 300px;"
                    @filter="(v) => filter('lists', v)"
                />
            </template>

            <template #filter-cell-title>
                <FilterInput
                    style="min-width: 120px;"
                    @search="(v) => filter('title', v)"
                />
            </template>
        </HamletTable>
    </Overlay>
</template>
